import React, { useEffect, useState} from 'react';
import {TabulatorFull as Tabulator} from "tabulator-tables"; //import Tabulator library
import "tabulator-tables/dist/css/tabulator.min.css"; //import Tabulator stylesheet

import { axiosService } from '@/_services/account.axios';
import Wait from '@/components/Wait';
import TitreH2 from '@/components/UI/titres/TitreH2';
import excelImg from '@/_images/excel.png';

const Adherents = () => {

    const [initialValue, setInitialValues] = useState({    
        flagButton: false,  //flag pour affichage boutons après reponse API
        nbAdherents: 0,
        nbValides: 0,
        userCanMajAdh: false,
        userCanValidAdh: false,
    })
    
    
    //initialisation du tableau////////////////////////////////
    useEffect(() => {
        if(initialValue.flagButton === false){

            //initialisation options requète API
            const options = {
                values: {
                    domaine:'front',
                    action:'listeAdherents',
                },
                OKData: (data) => {     //action callback déclanchée si tout est OK 
                    setInitialValues({
                        flagButton:true,
                        nbAdherents: data.nbAdherents,
                        nbValides: data.nbValides,
                        userCanMajAdh: data.userCanMajAdh,
                        userCanValidAdh: data.userCanValidAdh
                    });
                    afficheTableau(data);
                }
            }

            //lancement requète API
            axiosService.postAxios(options);
        }

        return;

    },[])

    // tableau des adhérents ///////////////////////////////////////
    const boutonClick = ()=>{
        window.location.href='/adherents/adhesion';
      }
    
    const divStyle={
        'justify-content':'center',
        padding:'50px',
        width:'min-content'
      }
    
    const boutonStyle={
        with:'25px',
        'margin-bottom':'25px'
    }

    const majAdhFormatter = () =>{
        return '<i class="fas fa-pen" style="color: #5f56c5;"></i>'
    }

    const dateSituationFormatter = cell =>{
        const dateSituation= new Date(cell.getData().dateSituation)
        return dateSituation.toLocaleDateString("fr")
    }
    
    const majValidFormatter = cell => {
        const color= cell.getData().situation== 'aRenouveler' ? 'style="color: #5f56c5;"' : '';
        return cell.getRow().getData().situation!=='validee' && cell.getRow().getData().situation!=='renouvelee' ?"<i class='fas fa-coins' "+ color + "></i>" : ""
      }
   
    const afficheTableau = (data)=>{
        console.log('userCan ' + data.userCanValidAdh);
        
        const listeAdherents = new Tabulator('#listeAdherents',{
            
            data:data.adherents,
            columnDefaults:{
            width:120,
            headerHozAlign:'center',
            },

            rowFormatter:function(row){
                row.getElement().classList.add("table-striped"); 
            },

            columns:[
            {title:"Nom", field:"nom", headerFilter:true},
            {title:"Pr&eacute;nom", field:"prenom"},
            {title:"Date Naissance", field:"dateNaissance",
                formatter:"datetime", formatterParams:{
                    inputFormat:"yyyy-mm-dd",
                    outputFormat:"dd/mm/yyyy",
                    invalidPlaceholder:"(date absente)",
                    timezone:"default",
                },
                width:140,
                hozAlign:'center'
            },          
            {title:"Adresse", field:"adresse", width: 160},
            {title:'Code Postal', field:'codePostal', width:80, hozAlign:'center'},
            {title:'Ville', field:'ville'},
            {title:'Email',field:'email',width:200},
            {title:'T&eacute;l&eacute;phone', field:'telephone',hozAlign:'center'},
            {formatter:majAdhFormatter,width:40,hozAlign:'center', cellClick:function(e,cell){if(data.userCanMajAdh) window.location.href='/adherents/majAdhesion/' + cell.getRow().getData().idAdherent}},
            {field: 'situation', formatter:majValidFormatter, width:40,hozAlign:'center', 
                cellClick:function(e,cell){if((cell.getRow().getData().situation==='demandee' || cell.getRow().getData().situation==='aRenouveler'  ) && data.userCanValidAdh) window.location.href='/adherents/validAdhesion/' 
                + cell.getRow().getData().idAdherent
                +'/' + cell.getRow().getData().nom
                +'/' + cell.getRow().getData().prenom
                +'/' + cell.getRow().getData().situation
            }},
            {title:'Date situation',field:"dateSituation",            
                formatter:"datetime", 
                formatterParams:{
                    inputFormat:"yyyy-mm-dd",
                    outputFormat:"dd/mm/yyyy",
                    invalidPlaceholder:"Avant 01/01/2024",
                    timezone:"default"
                },
                width:140,
                hozAlign:'center'
            }
            ],

            pagination:true,
            paginationSize:10,
            paginationSizeSelector:false, //enable page size select element and generate list options

            locale:true,
            langs:{
            "default":{
                "pagination":{
                "first":"1ere", //text for the first page button
                "last":"Derniere",
                "prev":"Preced.",
                "next":"Suivante",
                },
            }
            },
        });
    }


    return (
        <>
            {
                !initialValue.flagButton 
                ?
                <Wait />
                :
                initialValue.flagButton &&
                <div style={divStyle}>
                    <TitreH2 titre='Liste des adhérents' />
                    <div className='row'>
                        <button className='col-1' onClick={boutonClick} style={boutonStyle}>Ajouter</button>
                        <span className='col-5 offset-1 fst-italic fs-6 text-info'>
                            Nombre d'adhérents : {initialValue.nbAdherents} dont {initialValue.nbValides} à jour de leur cotisation
                        </span>
                        <a className='offest-4 col-5 mb-4' href={window.routes.URLAPI+'?domaine=front&action=exportExcel'}><img src={excelImg} style={{width:'50px'}}/></a>
                    </div>
                    <div ></div>
                    <div id='listeAdherents'></div>
                </div>
            }
        </>
    );
};

export default Adherents;